import { createApp } from "vue";

import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";

import "vuetify/styles";
import { createVuetify, ThemeDefinition } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

import { fa } from "vuetify/iconsets/fa";
import { aliases, mdi } from "vuetify/iconsets/mdi";

import "@mdi/font/css/materialdesignicons.css";
import "@fortawesome/fontawesome-free/css/all.css";

import App from "./App.vue";
import router from "./router";

import { maska } from "maska";

const libertaLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: "#EEEEEE",
    surface: "#FFFFFF",
    primary: "#F7A41C",
    secondary: "#EB6424",
    tertiary: "#F0E8DD",
    error: "#CC3333",
    info: "#2196F3",
    success: "#22CC44",
    warning: "#FB8C00",
    base: "#F2F4F5",
    "base-dark": "#F0E8DD",
    "orange-dark": "#EB6424",
  },
};
const vuetify = createVuetify({
  theme: {
    defaultTheme: "libertaLightTheme",
    themes: { libertaLightTheme },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
      fa,
    },
  },
  components,
  directives,
});
const pinia = createPinia();
pinia.use(
  createPersistedState({
    storage: sessionStorage,
  })
);

const app = createApp(App);

app.directive("maska", maska);

app.use(router).use(pinia).use(vuetify).mount("#app");
